import { AITOOLS_LOADING, AITOOLS_LIST, AITOOLS_PROMPTS_LIST } from './AiToolsActions';

const INITIAL_STATE = {
  isLoading: true,
  results: undefined,
  list: undefined,
  page: 0,
  total: 0,
};

const AiToolsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AITOOLS_LOADING: {
      return { ...state, isLoading: action.payload || true };
    }
    case AITOOLS_PROMPTS_LIST:
      return {
        ...state,
        list: action.payload.results,
      };
    case AITOOLS_LIST:
      return {
        ...state,
        isLoading: false,
        results: action.payload.results,
        page: action.payload.page,
        total: action.payload.total,
      };
    default:
      return { ...state };
  }
};

export default AiToolsReducer;
